import { useState } from "react";
import Select from "./Select";
import Field from "./Field";
import Button from "./Button";
import styles from "./PincodeSearch.module.css";

export default function PincodeSearch({ categories, onSearch }) {
  const [service_category, setCat] = useState(categories[0]?.value || "");
  const [pincode, setPin] = useState("");
  return (
    <form
      className={styles.bar}
      onSubmit={(e) => {
        e.preventDefault();
        onSearch({ service_category, pincode });
      }}
    >
      <Select
        id="category"
        label="Service"
        value={service_category}
        onChange={(e) => setCat(e.target.value)}
        options={categories}
      />
      <Field
        id="pincode"
        label="Pincode"
        value={pincode}
        onChange={(e) => setPin(e.target.value)}
        placeholder="e.g. 400001"
      />
      <div className={styles.action}>
        <Button type="submit">Find pros</Button>
      </div>
    </form>
  );
}
